import {KeyLabel} from '../../shared/domain/key-label.model';

export enum UserRole {
  ADMIN = 'ADMIN',
  READ_ONLY_ADMIN = 'READ_ONLY_ADMIN',
  PUBLISHER = 'PUBLISHER',
  CONTENT_OWNER = 'CONTENT_OWNER',
  SALES_REPRESENTATIVE = 'SALES_REPRESENTATIVE',
  CAMPAIGN_MANAGER = 'CAMPAIGN_MANAGER',
  REV_OPS = 'REV_OPS',
  DESIGNER = 'DESIGNER',
}

export const UserRoleLabels = {
  ADMIN: 'Admin',
  READ_ONLY_ADMIN: 'Read only Admin',
  PUBLISHER: 'Publisher',
  CONTENT_OWNER: 'Content owner',
  SALES_REPRESENTATIVE: 'Sales representative',
  CAMPAIGN_MANAGER: 'Campaign manager',
  REV_OPS: 'Rev Ops',
  DESIGNER: 'Designer',
};

export const UserRoleKL = () =>
  (Object.keys(UserRole).map(key => new KeyLabel(<UserRole> key, UserRoleLabels[key])));
